import styled from 'styled-components';

export const MainContainer = styled.main`
  margin: 0 auto;
  max-width: 1250px;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 10px;
  @media screen and (min-width: 380px) {
    padding-left: 15px;
    padding-right: 15px;
  }
`;
